export const directApplySyncQueryKeys = {
  all: ["integrations", "direct-apply"] as const,
  comparison: (integrationName: string, clientId: string, from: string, to: string) =>
    [...directApplySyncQueryKeys.all, integrationName, "sync", clientId, from, to] as const,
};
